import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../libs'
import { Competitions, CompetitionRequest, CompetitionResponse } from './types'

export const competitionsListMounted = createEvent<CompetitionRequest>()

export const getCompetitions = fx<CompetitionRequest, CompetitionResponse>({
  method: 'GET',
  url: `/promo/ramadan_2026/promo_day`,
})

export const $competitions = restore<Competitions[]>(
  getCompetitions.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfCompetitions = restore(
  getCompetitions.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: competitionsListMounted,
  fn: ({ limit, page, orderBy, orderDirection }) => {
    if (orderDirection === 'descend') {
      orderDirection = '-'
    } else if (orderDirection === 'ascend') {
      orderDirection = ''
    }

    let query = {
      limit,
      page,
    }

    if (orderBy) {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }

    // @ts-ignore
    query['populate'] =
      '["Ramadan2026PromoDay.dayId","Ramadan2026PromoDay.clients","Ramadan2026PromoDay.type","Ramadan2026PromoDay.status", "Ramadan2026PromoDay.sumLots"]'

    return {
      query,
    }
  },
  target: getCompetitions,
})
